module.exports = __webpack_public_path__ + "static/img/activity_sdy_06-3.27d8add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_06-3.jpg
// module id = A1dR
// module chunks = 0